import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import AccessDenied from './views/AccessDenied.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('./views/Home.vue'),
    },
    {
      path: '/session',
      name: 'Session',
      component: () => import('./views/Session.vue'),
    },
    {
      path: '/test',
      name: 'Test',
      component: () => import('./views/Test.vue'),
    },
    {
      path: '/search',
      name: 'Search',
      component: () => import('./views/Search.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/access-denied',
      name: 'AccessDenied',
      component: AccessDenied,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isAuthenticated = (store.state.session.user !== null);

  if (requiresAuth && !isAuthenticated) {
    next('/access-denied');
  } else {
    next();
  }
});

export default router;